// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-wrapper {
  cursor: pointer;
}
.radio-wrapper input {
  display: none;
}
.radio-wrapper .label-wrapper .label {
  color: #101010;
}
.radio-wrapper .label-wrapper .sub-text {
  color: #717171;
}
.radio-wrapper .radio-select {
  padding: 2px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #FDFDFD;
  border: 1px solid #B7B7B7;
}
.radio-wrapper:hover .radio-select {
  border: 1px solid #101010;
}
.radio-wrapper.checked .radio-select {
  border: 7px solid #101010;
}
.radio-wrapper.disabled {
  cursor: not-allowed;
}
.radio-wrapper.disabled .radio-select {
  border: 1px solid #E7E7E7;
}
.radio-wrapper.disabled.checked .radio-select {
  border: 7px solid #E7E7E7;
}
.radio-wrapper.disabled .label-wrapper .label,
.radio-wrapper.disabled .label-wrapper .sub-text {
  color: #B7B7B7;
}`, "",{"version":3,"sources":["webpack://./src/components/radio/style.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,aAAA;AACJ;AAGI;EACE,cAAA;AADN;AAII;EACE,cAAA;AAFN;AAME;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAJJ;AAQI;EACE,yBAAA;AANN;AAWI;EACE,yBAAA;AATN;AAaE;EACE,mBAAA;AAXJ;AAaI;EACE,yBAAA;AAXN;AAcI;EACE,yBAAA;AAZN;AAgBM;;EAEE,cAAA;AAdR","sourcesContent":[".radio-wrapper {\n  cursor: pointer;\n\n  input {\n    display: none;\n  }\n\n  .label-wrapper {\n    .label {\n      color: theme('colors.black');\n    }\n\n    .sub-text {\n      color: theme('colors.grey-70');\n    }\n  }\n\n  .radio-select {\n    padding: 2px;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background-color: theme('colors.white');\n    border: 1px solid theme('colors.grey-50');\n  }\n\n  &:hover {\n    .radio-select {\n      border: 1px solid theme('colors.black');\n    }\n  }\n\n  &.checked {\n    .radio-select {\n      border: 7px solid theme('colors.black');\n    }\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n\n    .radio-select {\n      border: 1px solid theme('colors.grey-30');\n    }\n\n    &.checked .radio-select {\n      border: 7px solid theme('colors.grey-30');\n    }\n\n    .label-wrapper {\n      .label,\n      .sub-text {\n        color: theme('colors.grey-50');\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
